import { Flex, Form, FormInstance, TableColumnsType } from 'antd';
import * as Component from 'components';
import {
  TransferDataHandlerInterface,
  TransferDataSourceInterface,
} from 'components/transfer/Transfer';
import { seriesService } from 'content/service';
import { SeriesInterface } from 'content/type/seriesType';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { playlistRuleService } from '../services/playlistRuleService';

export const SeriesRule: React.FC<{
  form: FormInstance;
}> = ({ form }) => {
  const { id } = useParams<{ id: string }>();
  const [, setRefreshKey] = useState(0);

  const columns: TableColumnsType<TransferDataSourceInterface> = [
    {
      dataIndex: 'id',
      title: 'Id',
      width: '10%',
    },
    {
      dataIndex: 'name',
      title: 'Name',
      render: (_, record): React.ReactNode => {
        return (
          <Flex align="center" gap="small">
            <span>{record.name}</span>
          </Flex>
        );
      },
    },
  ];

  const mapToTransferItem = (series: SeriesInterface): TransferDataSourceInterface => ({
    ...series,
    key: series.id,
    name: series.title,
    disabled: false,
    poster: undefined,
  });

  const filterOption = (input: string, item: SeriesInterface): boolean =>
    item.title?.includes(input);

  const dataHandler: TransferDataHandlerInterface = {
    fetchSourceData: async (query: Record<string, string>) => {
      const extendedQuery = new URLSearchParams(query);
      extendedQuery.append('order_by', 'id');
      const series = await seriesService.fetch(extendedQuery);
      return {
        data: series.results.map(mapToTransferItem),
        count: series.count,
      };
    },
    fetchTargetData: async (query: Record<string, string>) => {
      const extendedQuery = new URLSearchParams(query);
      extendedQuery.append('order_by', 'id');
      const series = await playlistRuleService.fetchSeriesRules(form, Number(id), extendedQuery);
      return {
        data: series.results.map(mapToTransferItem),
        count: series.count,
      };
    },
    createWithParentId: async (ids: number[]) => {
      const seriesIds = form.getFieldValue('series');
      if (!seriesIds) {
        form.setFieldValue('series', ids);
      } else {
        const deduplicatedIds = [...new Set([...seriesIds, ...ids])];
        form.setFieldValue('series', deduplicatedIds);
      }
      setRefreshKey(prev => prev + 1);
    },
    deleteWithParentId: async (ids: number[]) => {
      const seriesIds = form.getFieldValue('series');
      const deduplicatedIds = seriesIds.filter((id: number) => !ids.includes(id));
      form.setFieldValue('series', deduplicatedIds);
      setRefreshKey(prev => prev + 1);
    },
  };

  return (
    <div>
      <h3 style={{ display: 'flex', alignItems: 'center' }}>
        <span>Series</span>
        <span
          style={{
            flex: 1,
            borderBottom: '1px solid #666',
            marginLeft: '8px',
            height: '0.5em',
          }}
        />
      </h3>
      <Form.Item name="series" noStyle>
        <Component.TransferComponent
          dataHandler={dataHandler}
          filterOption={filterOption}
          columns={columns}
        />
      </Form.Item>
    </div>
  );
};
